import React, { Component } from 'react';
import { Popover } from 'antd';

class _Popover extends Component {
  state = {
    visible: false,
  };
  hide = () => {
    this.setState({
      visible: false,
    });
  };

  composed = (data, length) => `${data.substring(0, length)}.. `;

  handleVisibleChange = visible => {
    this.setState({ visible });
  };
  render() {
    return (
      <Popover
        content={this.props.data}
        title={this.props.title}
        trigger="click"
        visible={this.state.visible}
        onVisibleChange={this.handleVisibleChange}
        overlayStyle={{ wordWrap: 'break-word', width: '300px' }}
      >
        {this.composed(this.props.data, this.props.length)}
        <a>more</a>
      </Popover>
    );
  }
}

export default _Popover;



// WEBPACK FOOTER //
// ./src/components/UI/Popover/Popover.js